import { memo } from 'react';

import { useAnnotationV2Store } from '~/components/AnnotationsV2/providers/AnnotationV2Provider';
import { RangePlaybackProgressBar } from '~/components/v2/components/asset-modal/visualizer/video/VideoCommentRangeSelector/RangePlaybackProgressBar';

type VideoCommentRangeBarPlaybackProgressProps = {
  isRangeDragging?: boolean;
};

export const VideoCommentRangeBarPlaybackProgress = memo(
  ({ isRangeDragging = false }: VideoCommentRangeBarPlaybackProgressProps) => {
    const commentRange = useAnnotationV2Store((state) => state.commentRange);

    if (isRangeDragging || !commentRange) {
      return null;
    }

    return (
      <RangePlaybackProgressBar
        data-testid="VIDEO_COMMENT_RANGE_BAR_PLAYBACK_PROGRESS"
        endTime={commentRange.endTime}
        startTime={commentRange.startTime}
      />
    );
  },
);

VideoCommentRangeBarPlaybackProgress.displayName = 'VideoCommentRangeBarPlaybackProgress';
